<template>
    <div class="row">
        <div class="col-lg-10 pt-4 pb-2">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6 offset-lg-3 mb-2">

                        <div class="card-wrapper card-space">
                            <div class="card card-bg no-after">
                                <div class="card-body">

                                    <form @submit.prevent="createScreening" autocomplete="off">

                                        <div class="form-group">

                                            <label for="title">Titolo</label>
                                            <input type="text" class="form-control text-uppercase" id="title" aria-describedby="title_info" v-model.trim="$v.form.screening.title.$model" v-bind:class="{'is-invalid': (!$v.form.screening.title.required || !$v.form.screening.title.minLength) && $v.form.screening.title.$dirty}">
                                            
                                            <small v-show="!$v.form.screening.title.$dirty || !$v.form.screening.title.$invalid" id="title_info" class="form-text text-muted">Il titolo digitato dovrà essere univoco</small>
                                            
                                            <div v-show="!$v.form.screening.title.required && $v.form.screening.title.$dirty" class="invalid-feedback">Titolo richiesto</div>
                                            <div v-show="!$v.form.screening.title.minLength && $v.form.screening.title.$dirty" class="invalid-feedback">Digitare minimo 3 caratteri</div>

                                        </div>
                                        <div class="form-group">

                                            <label for="description">Descrizione</label>
                                            <textarea id="description" class="form-control border" rows="2" v-model.trim="$v.form.screening.description.$model" v-bind:class="{'is-invalid border-danger': (!$v.form.screening.description.required || !$v.form.screening.description.minLength) && $v.form.screening.description.$dirty}"></textarea>
                                            
                                            <small v-show="!$v.form.screening.description.$dirty || !$v.form.screening.description.$invalid" id="title_info" class="form-text text-muted">Fornire una breve descrizione</small>
                                            
                                            <div v-show="!$v.form.screening.description.required && $v.form.screening.description.$dirty" class="invalid-feedback">Descrizione richiesta</div>
                                            <div v-show="!$v.form.screening.description.minLength && $v.form.screening.description.$dirty" class="invalid-feedback">Digitare minimo 8 caratteri</div>

                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-md-6">

                                                <label for="from_age" class="active">Età inizio copertura</label>
                                                <input type="number" class="form-control" id="from_age" min="1" aria-describedby="from_age" v-model.trim="$v.form.screening.from_age.$model" v-bind:class="{'is-invalid': (!$v.form.screening.from_age.required || !$v.form.screening.from_age.numeric || !$v.form.screening.from_age.minValue) && $v.form.screening.from_age.$dirty}">

                                                <small v-show="!$v.form.screening.from_age.$dirty || !$v.form.screening.from_age.$invalid" id="title_info" class="form-text text-muted">Specificare età paziente</small>

                                                <div v-show="!$v.form.screening.from_age.required && $v.form.screening.from_age.$dirty" class="invalid-feedback">Età richiesta</div>
                                                <div v-show="!$v.form.screening.from_age.numeric && $v.form.screening.from_age.$dirty" class="invalid-feedback">Ammessi solo numeri</div>
                                                <div v-show="!$v.form.screening.from_age.minValue && $v.form.screening.from_age.$dirty" class="invalid-feedback">Età minima di 1 anno</div>

                                            </div>
                                            <div class="form-group col-md-6">
                                                <label for="to_age">Età fine copertura</label>
                                                <input type="number" class="form-control" id="to_age" :min="form.screening.from_age" :disabled="!$v.form.screening.from_age.required || !$v.form.screening.from_age.numeric || !$v.form.screening.from_age.minValue" aria-describedby="to_age" v-model.trim="$v.form.screening.to_age.$model" v-bind:class="{'is-invalid': (!$v.form.screening.to_age.required || !$v.form.screening.to_age.numeric || !$v.form.screening.to_age.minValue) && $v.form.screening.to_age.$dirty}">

                                                <small v-show="!$v.form.screening.to_age.$dirty || !$v.form.screening.to_age.$invalid" id="title_info" class="form-text text-muted">Specificare età paziente</small>

                                                <div v-show="!$v.form.screening.to_age.required && $v.form.screening.to_age.$dirty" class="invalid-feedback">Età richiesta</div>
                                                <div v-show="!$v.form.screening.to_age.numeric && $v.form.screening.to_age.$dirty" class="invalid-feedback">Ammessi solo numeri</div>
                                                <div v-show="!$v.form.screening.to_age.minValue && $v.form.screening.to_age.$dirty" class="invalid-feedback">Età minima di {{form.screening.from_age}} anni</div>
                                            </div>
                                        </div>

                                        <div class="form-check">
                                            <input id="for_man" type="checkbox" v-model.trim="$v.form.screening.for_man.$model">
                                            <label for="for_man" v-bind:class="{'text-danger': !$v.form.screening.for_man.required}">Screening dedicato all'uomo</label>
                                        </div>
                                        <div class="form-check">
                                            <input id="for_woman" type="checkbox" v-model.trim="$v.form.screening.for_woman.$model">
                                            <label for="for_woman" v-bind:class="{'text-danger': !$v.form.screening.for_woman.required}">Screening dedicato alla donna</label>
                                        </div>

                                        <div v-show="!$v.form.screening.for_man.required || !$v.form.screening.for_woman.required" class="alert alert-danger">
                                            Selezionare almeno un sesso
                                        </div>

                                        <div class="form-group mt-4">

                                            <label for="color" class="active">Colore</label>
                                            <input type="color" class="form-control border-bottom" id="color" aria-describedby="color" v-model="form.screening.color">
                                            <small id="title_info" class="form-text text-muted">Il colore dovrà essere univoco</small>
                                        
                                        </div>

                                        <p class="font-weight-bold">Associa un test allo screening</p>

                                        <div v-for="test of DB.tests" :key="test.id" class="form-check form-check-group">
                                            <input :id="test.title" type="checkbox" :aria-labelledby="`${test.title}-help`" @change="updateScreeningTest($event, test)">
                                            <label :for="test.title">{{test.title}}</label>
                                            <small :id="`${test.title}-help`" class="form-text">{{test.description}}</small>
                                        </div>

                                        <div class="alert alert-danger" v-show="validation.ko">
                                            {{validation.ko}}
                                        </div>

                                        <div class="it-card-footer">

                                            <button type="submit" class="btn btn-primary" :disabled="$v.form.screening.$invalid || loaders.creating.screening">
                                                
                                                <span v-show="!loaders.creating.screening">
                                                    Aggiungi
                                                </span>

                                                <div class="progress-spinner progress-spinner-double size-sm progress-spinner-active" v-show="loaders.creating.screening">
                                                    <div class="progress-spinner-inner"></div>
                                                    <div class="progress-spinner-inner"></div>
                                                    <span class="sr-only">Caricamento...</span>
                                                </div>
                                                

                                            </button>

                                        </div>

                                    </form>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-2 border-left-lg">
            <div class="sidebar-wrapper">
                <div class="sidebar-linklist-wrapper">
                    <div class="link-list-wrapper">
                        <ul class="link-list text-lg-right">
                            <li>
                                <h3 class="text-truncate">Funzioni</h3>
                            </li>
                            <li>
                                <a class="list-item medium text-truncate disabled">
                                    
                                    <i class="text-muted">Nessuna funzione</i>

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { 
        required,
        minLength,
        maxLength,
        numeric,
        minValue
    } from "vuelidate/lib/validators"

    export default {
        data() {
            return {
                DB: {
                    tests: []
                },
                form: {
                    screening: {
                        title:       null,
                        description: null,
                        from_age:    1,
                        to_age:      null,
                        for_man:     false,
                        for_woman:   false,
                        color:       `#fff`,
                        screenings_tests: {
                            create: []
                        }
                    }
                },
                loaders: {
                    creating: {
                        screening: false
                    }
                },
                validation: {
                    ko: false
                }
            }
        },
        validations() {
            return {
                form: {
                    screening: {
                        title: {
                            required,
                            minLength: minLength(3)
                        },
                        description: {
                            required,
                            minLength: minLength(8),
                            maxLength: maxLength(350)
                        },
                        from_age: {
                            required,
                            numeric,
                            minValue: minValue(1)
                        },
                        to_age: {
                            required,
                            minValue: minValue(this.form.screening.from_age),
                            numeric
                        },
                        for_man: {
                            required() {
                                return !(!this.form.screening.for_woman && !this.form.screening.for_man)
                            }
                        },
                        for_woman: {
                            required() {
                                return !(!this.form.screening.for_man && !this.form.screening.for_woman)
                            }
                        }
                    }

                }
            }
        },
        methods: {

            async createScreening() {

                this.loaders.creating.screening = true
                this.validation.ko              = false

                try {

                    const res = await this.axios.post(`user/screenings/create/single`, this.form.screening, {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.$toast.open({
                        message: res.data.message,
                        type:   `success`
                    })

                    this.$router.push(`/admin/screenings`)

                }
                catch(e) {

                    const message = e.response.data.message

                    this.$toast.open({
                        message,
                        type: `error`
                    })

                    this.validation.ko         = message
                    this.loaders.creating.screening = false

                }
            },
            async readTests() {
                try {

                    const tests = await this.axios.get(`user/tests/read/actives`,  {
                        headers:{
                            Authorization: `bearer ${this.$store.state.auth.token}`
                        }
                    })

                    this.DB.tests = tests.data.tests_db
                    
                }
                catch(e) {
                    if(e.response.status == 401 && e.response.statusText == `Unauthorized`) {

                        this.$toast.open({
                            message: `La tua sessione è scaduta, effettua nuovamente il login`,
                            type:    `error`
                        })

                        this.$router.push('/sessionescaduta')
                    }
                    else {
                        this.$toast.open({
                            message: `Non è momentaneamente possibile scaricare i tests. ${e.response.data.message ? e.response.data.message + '. ' : 'Riprovi più tardi.'}`,
                            type:    `error`
                        })
                    }

                }
            },

            updateScreeningTest(event, value) {

                const state = event.target.checked

                state ? this.push(value) : this.pop(value)

            },
            push(value) {

                // Al check inseriamo l'elemento
                this.form.screening.screenings_tests.create.push({
                    id_test: value.id
                })

            },
            pop(value) {

                // Al "uncheck" cherchiamo elemento e rimuoviamolo
                for(let key in this.form.screening.screenings_tests.create) {

                    if(this.form.screening.screenings_tests.create[key].id_test == value.id) {
                        this.form.screening.screenings_tests.create.splice(key, 1)
                    }

                }

            }

        },
        mounted() {
            this.readTests()
        }
    }
</script>